var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 438,
    viewBox: "0 0 1440 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-130 162.552C-77.0275 139.191 48.1638 105.435 140.684 133.351C273.406 173.398 452.864 389.31 614.526 422.862C934.107 489.19 1132.93 307.159 1296.77 187.582C1454.52 72.4463 1521.85 78.9816 1543 82.4579",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-130 127.552C-77.0275 104.191 48.1638 70.4345 140.684 98.3511C273.406 138.398 452.864 354.31 614.526 387.862C934.107 454.19 1132.93 272.159 1296.77 152.582C1454.52 37.4463 1521.85 43.9816 1543 47.4579",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-130 82.5521C-77.0275 59.1913 48.1638 25.4345 140.684 53.3511C273.406 93.3982 452.864 309.31 614.526 342.862C934.107 409.19 1132.93 227.159 1296.77 107.582C1454.52 -7.55372 1521.85 -1.01837 1543 2.45794",
    stroke: "white",
    strokeOpacity: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLines);
export default __webpack_public_path__ + "static/media/bgLines.ded66a6a5593970eb259a8a2151effb9.svg";
export { ForwardRef as ReactComponent };